import { render, staticRenderFns } from "./BoundaryOrgModal.vue?vue&type=template&id=3f1d41be&scoped=true"
import script from "./BoundaryOrgModal.vue?vue&type=script&lang=js"
export * from "./BoundaryOrgModal.vue?vue&type=script&lang=js"
import style0 from "./BoundaryOrgModal.vue?vue&type=style&index=0&id=3f1d41be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f1d41be",
  null
  
)

export default component.exports